// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"79":"da07ad87","228":"58443328","238":"ddc9b15d","644":"a630a0f4","843":"899e0017","852":"e1a183d1"}[chunkId] + ".chunk.css";
};